import FireBaseHelperOwn from "../firebase";
import GenerateHTML from "./generate-html.js";
import Spinner from "../spinner.js";
import Register from "../register/register.js";
// import startUp from "../main-start-up-screen/start-up.js";
// import handleAccount from "../register/handle-account.js";
import GENRALHELPERS from "../GENRAL-HELPERS.js";
import spinner from "../spinner.js";
import firebase from "../firebase";
import yourListings from "../main-menu/your-listings.js";
import accountProfileChange from "../main-menu/account-profile-change.js";
import DisplayBusinessOwn from "../business-page-own-veiw/busine-own.js";
import generateHtml from "../dispay-listings-each/generate-html.js";
import display from "../dispay-listings-each/display.js";
import allHandeling from "../handeling-all-displays/all-handeling.js";
import signUpProfile from "../sign-up_profile/signUpProfile.js";

import iconWhiteDrag from "../../../Icons/NV/white/drag-white.png";
import settings from "../settings.js";


import { Clipboard } from '@capacitor/clipboard';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { Geolocation } from '@capacitor/geolocation';
import { set } from "firebase/database";
import busineOwn from "../business-page-own-veiw/busine-own.js";
import nav from "../home-screen/nav.js";

let listingDataEmpty = {
  listingName: "",
  listingMachineType: "",
  listingBrand: "",
  listingModel: "",
  listingCondition: "",
  listingYear: "",
  listingPrice: "",
  listingPriceMarkedAs: "",
  listingItemsAvailable: 0,
  listingCoin: "",
  listingDescription: "",
  listingTokens: [],
  onDiscount: {
    finalPrice: "",
    percent: "",
    amount: "",
  },
  listingMainImg: "",
  listingImgsIds: [],
  listingWhatsAppNumber: "",
  listingCallNumber: "",
  listingMarkedAs: "",
  videoUrl: "",
  adminNotes: "",
  place: {
    description: "",
    lat: "",
    lng: "",
    locationUrl: "",
    name: "",
    city: "",
    country: "",
    state: "",
  },
  filterLat: '',
  filterLng: '',
  filterState: '',
  filterCountry: '',
  filterCity: '',
  filterGeoHash: '',
};

let listingData = {
  listingName: "",
  listingMachineType: "",
  listingBrand: "",
  listingModel: "",
  listingCondition: "",
  listingYear: "",
  listingPrice: "",
  listingPriceMarkedAs: "",
  listingItemsAvailable: 0,
  listingCoin: "",
  listingDescription: "",
  listingTokens: [],
  onDiscount: {
    finalPrice: "",
    percent: "",
    amount: "",
  },
  listingMainImg: "",
  listingImgsIds: [],
  listingWhatsAppNumber: "",
  listingCallNumber: "",
  listingMarkedAs: "",
  videoUrl: "",
  adminNotes: "",
  place: {
    description: "",
    lat: "",
    lng: "",
    locationUrl: "",
    name: "",
    city: "",
    country: "",
    state: "",
  },
  filterLat: '',
  filterLng: '',
  filterState: '',
  filterCountry: '',
  filterCity: '',
  filterGeoHash: '',
};

class CreateListing {
  #machineBrandsOnCleared = false;
  #machineModelsOnCleared = false;
  #initialPreselectedSet = false;
  #prefixId = "";
  #publishIn = null;
  #isInEdit = false;
  #listingId = null;
  #businessId = null;
  #listingCreatedAt;
  #listingUpdatedAt;
  #newType = false;
  #newPlace = false;
  #isValidVideo = false;

  #eventsInitialized = false;
  #CTAShareEventsInitialized = false;

  #finalPublishListingButtonActivated = false


  #hasChanges = false


  #loadedOptionsDataCategories = null
  #loadedOptionsDataBrands = null
  #loadedOptionsDataModels = null

  #publishNowButtonFinalClickedAt = 0
  #isStillUploadingImages = false

  async _init(dataIn, draftId) {
    this.#hasChanges = false
    if (this.#isStillUploadingImages) {
      alert("Por favor espera a que se complete la subida de imágenes antes de continuar.");
      return
    }

    console.log(draftId);

    // GENRALHELPERS._startTimer('createListingInit')



    console.log(dataIn);
    this.#initialPreselectedSet = false;
    this.#eventsInitialized = false
    this.#newType = false;
    this.#newPlace = false

    this.#prefixId = GENRALHELPERS._getUniqueIdfunction();
    const account = firebase._getLatestCurrentUserData();

    if (!account) {
      Register._displayOptions("create_listing");
      return;
    } else {
      if (!account.whatsAppNumber) {
        // accountProfileChange._open();
        alert("Debes tener un perfil de vendedor para poder publicar listados.");
        signUpProfile._open(true)
        return;
      }
      let drafts = []

      if (dataIn) {


        if (dataIn?.place) {
          listingData = dataIn;


          if (listingData?.adminNotes) {

          } else {

            listingData = {
              ...dataIn,

              adminNotes: "",
              videoUrl: "",
            }
          }



        } else {

          listingData = {
            ...dataIn,

            adminNotes: "",
            videoUrl: "",
            place: {
              description: "",
              lat: "",
              lng: "",
              locationUrl: "",
              name: "",
              city: "",
              country: "",
              state: "",
            },

            filterLat: dataIn?.filterLat ?? '',
            filterLng: dataIn?.filterLng ?? '',
            filterState: dataIn?.filterState ?? '',
            filterCountry: dataIn?.filterCountry ?? '',
            filterCity: dataIn?.filterCity ?? '',
            filterGeoHash: dataIn?.filterGeoHash ?? '',
          }
        }




        this.#isInEdit = true;
        this.#listingId = dataIn.listingId;
        this.#businessId = dataIn.businessId;
        this.#listingCreatedAt = dataIn.createdAt;
        this.#listingUpdatedAt = dataIn.updatedAt;

        if (!listingData.listingItemsAvailable) {
          listingData.listingItemsAvailable = 0;
        }
      } else {

        spinner._displaySpinner("Cargando...");
        drafts = await this._getDrafts()
        drafts.splice(
          0,
          drafts.length,
          ...drafts.filter(draft => draft.uploadStatus !== 'uploading')
        );
        spinner._hideSpinner();
        console.log(drafts);


        if (draftId) {
          const draft = drafts.find(
            draft => draft.prefixId === Number(draftId)
          );
          console.log(draft, "draft encontrado");
          if (draft) {
            drafts = [draft]
          } else {
            drafts = []
          }
        }

        const hiddenStatuses = [
          'uploading',
        ];

        drafts = drafts.filter(
          draft => !hiddenStatuses.includes(draft.status)
        );

        if (drafts?.length > 0 && !draftId) {
          const action = await this._confirmContinueListing();
          const modal = document.getElementById('confirmContinueListingConMain');

          if (action === 'new') {
            drafts = []

            modal.style.display = 'none';
          }

          if (action === 'seeDrafts') {
            modal.style.display = 'none';
            busineOwn._init('listing-drafts');
            return

            // const con = document.getElementById(
            //   `SearchStartUpComponentAllCon`
            // );
            // con.remove();
          }

          if (action === 'cancel') {
            modal.style.display = 'none';
            return
          }

          if (action === 'Continue') {
            modal.style.display = 'none';
          }

        }


        listingData.listingName = drafts[0]?.listingName || "";
        listingData.listingMachineType = drafts[0]?.listingMachineType || "";
        listingData.listingBrand = drafts[0]?.listingBrand || "";
        listingData.listingModel = drafts[0]?.listingModel || "";
        listingData.listingCondition = drafts[0]?.listingCondition || "";
        listingData.listingYear = drafts[0]?.listingYear || "";
        listingData.listingPrice = drafts[0]?.listingPrice || "";
        listingData.listingCoin = drafts[0]?.listingCoin || "";
        listingData.listingDescription = drafts[0]?.listingDescription || "";
        listingData.listingMainImg = drafts[0]?.listingMainImg || "";
        listingData.listingMarkedAs = drafts[0]?.listingMarkedAs || "";
        listingData.listingPriceMarkedAs = drafts[0]?.listingPriceMarkedAs || "";
        listingData.listingImgsIds = [];
        listingData.listingWhatsAppNumber = drafts[0]?.listingWhatsAppNumber || "";
        listingData.listingCallNumber = drafts[0]?.listingCallNumber || "";
        listingData.listingItemsAvailable = drafts[0]?.listingItemsAvailable || 0;
        listingData.videoUrl = drafts[0]?.videoUrl || "";
        listingData.adminNotes = drafts[0]?.adminNotes || "";

        if (drafts[0]?.place) {
          listingData.place = drafts[0]?.place;
          listingData.filterLat = drafts[0]?.filterLat ?? ''
          listingData.filterLng = drafts[0]?.filterLng ?? ''
          listingData.filterState = drafts[0]?.filterState ?? ''
          listingData.filterCountry = drafts[0]?.filterCountry ?? ''
          listingData.filterCity = drafts[0]?.filterCity ?? ''
          listingData.filterGeoHash = drafts[0]?.filterGeoHash ?? ''

        } else {

          listingData.place = {
            description: "",
            lat: "",
            lng: "",
            locationUrl: "",
            name: "",
            city: "",
            country: "",
            state: "",
          }

          listingData.filterLat = ''
          listingData.filterLng = ''
          listingData.filterState = ''
          listingData.filterCountry = ''
          listingData.filterCity = ''
          listingData.filterGeoHash = ''
        }

        console.log('listingData', listingData);


        this.#isInEdit = false;
        this.#listingId = null;
        this.#businessId = null;
        this.#listingCreatedAt = null;
        this.#listingUpdatedAt = null;
      }

      if (!listingData.onDiscount) {
        listingData["onDiscount"] = {
          finalPrice: listingData.listingPrice,
          amount: 0,
          percent: 0,
        };
      }
      console.log(this.#listingId);

      console.log(listingData);
      const container = document.getElementById("MainAppContentContainer");
      const content = GenerateHTML._display(listingData);
      const numberOfListingsAvailable = document.querySelector(
        ".numberOfListingsAvailable"
      );
      if (numberOfListingsAvailable) {
        numberOfListingsAvailable.remove();
      }

      container.insertAdjacentHTML("beforeend", content);

      let imgs = dataIn?.listingImgsIds

      if (dataIn?.listingImgsIds[0]?.res_20) {
        imgs = []

        dataIn?.listingImgsIds.forEach(imgSet => {
          imgs.push(imgSet?.res_original)
        });
      } else {
        imgs = []
        // drafts[0]?.images?.forEach(img => {
        //   console.log(img);
        //   imgs.push(img?.src)
        // });

        drafts[0]?.images?.forEach(img => {

          const url = URL.createObjectURL(img.blob);

          imgs.push(url);

        });
      }

      if (drafts?.length > 0) {
        this._deleteDraft(drafts[0]?.prefixId)
      }

      if (imgs?.length > 0) {
        this.#hasChanges = true
      }


      this._imageHandle(imgs);
      this.#finalPublishListingButtonActivated = false
      this._events(this.#prefixId);
      this._eventsForOptions(this.#prefixId);

      this._initializeCatBrandModelSelects(listingData?.listingMachineType, listingData?.listingBrand, listingData?.listingModel)
      this._initializeYearSelect(listingData?.listingYear)
      this._initializeConditionSelect(listingData?.listingCondition)

      this._setOtherData();



      document.querySelectorAll('input, textarea').forEach(el => {
        el.addEventListener('focus', () => {
          document.body.style.overflow = 'hidden';
        });

        el.addEventListener('blur', () => {
          document.body.style.overflow = '';
        });
      });

      const titleInput = document.getElementById('CreateListingName');

      function autoGrow() {
        titleInput.style.height = 'auto';
        titleInput.style.height = titleInput.scrollHeight + 'px';
      }

      titleInput.addEventListener('input', autoGrow);
      autoGrow();


      this._eventsForMoreOptions();

    }
  }



  // START Draft

  // _getUploadImages() {
  //   const imagesCon = document.getElementById('uploaded-images-container');
  //   const images = imagesCon.querySelectorAll('.uploadSpecific');

  //   return Array.from(images).map(img => ({
  //     src: img.src,
  //     alt: img.alt || ''
  //   }));
  // }

  async _getUploadImages() {

    const imagesCon = document.getElementById(
      'uploaded-images-container'
    );

    const images = imagesCon.querySelectorAll(
      '.uploadSpecific'
    );

    const result = [];

    for (const img of images) {

      const response = await fetch(img.src);

      const blob = await response.blob();

      result.push({
        blob
      });

    }

    return result;
  }

  _openDraftDB() {
    return new Promise((resolve, reject) => {

      const request = indexedDB.open('listingDraftsDB', 1);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;

        if (!db.objectStoreNames.contains('drafts')) {
          db.createObjectStore('drafts', {
            keyPath: 'prefixId'
          });
        }
      };

      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);

    });
  }

  async _saveDraft(prefixIdIn, uploadStatus) {

    console.log('Saving draft...', prefixIdIn);

    const prefixId = prefixIdIn || Date.now();

    const images = await this._getUploadImages();

    const dataToStore = {
      ...listingData,
      images,
      uploadStatus,
      prefixId,
      savedAt: Date.now()
    };

    const db = await this._openDraftDB();

    const tx = db.transaction('drafts', 'readwrite');

    tx.objectStore('drafts').put(dataToStore);

    return new Promise((resolve, reject) => {

      tx.oncomplete = () => resolve(dataToStore);
      tx.onerror = () => reject(tx.error);

    });
  }

  async _getDrafts() {

    const db = await this._openDraftDB();

    return new Promise((resolve, reject) => {

      const request = db
        .transaction('drafts', 'readonly')
        .objectStore('drafts')
        .getAll();

      request.onsuccess = () => {

        const drafts = request.result.sort(
          (a, b) => b.savedAt - a.savedAt
        );

        resolve(drafts);
      };

      request.onerror = () =>
        reject(request.error);

    });
  }

  async _getDraft(prefixId) {

    const db = await this._openDraftDB();

    return new Promise((resolve, reject) => {

      const request = db
        .transaction('drafts', 'readonly')
        .objectStore('drafts')
        .get(prefixId);

      request.onsuccess = () =>
        resolve(request.result);

      request.onerror = () =>
        reject(request.error);

    });
  }

  async _deleteDraft(prefixId) {

    const db = await this._openDraftDB();

    return new Promise((resolve, reject) => {

      const request = db
        .transaction('drafts', 'readwrite')
        .objectStore('drafts')
        .delete(Number(prefixId));

      request.onsuccess = () =>
        resolve('deleted');

      request.onerror = () =>
        reject(request.error);

    });
  }
  // END Draft

  _eventsForMoreOptions() {
    const CreateListingOptionalMoreDescriptionSection = document.getElementById('CreateListingOptionalMoreDescriptionSection')
    const CreateListingOptionalCategorySection = document.getElementById('CreateListingOptionalCategorySection')
    const CreateListingOptionalItemsAvailableSection = document.getElementById('CreateListingOptionalItemsAvailableSection')
    const CreateListingMoreOptionsButton = document.getElementById('CreateListingMoreOptionsButton')

    const CreateListingOptionsPicPriceMArkedAs = document.getElementById('CreateListingOptionsPicPriceMArkedAs')
    const CreateListingDiscount = document.getElementById('CreateListingDiscount')
    const CreateListingPriceMoreOptionsCon = document.getElementById('CreateListingPriceMoreOptionsCon')
    const CreateListingPriceMoreOptionsButton = document.getElementById('CreateListingPriceMoreOptionsButton')

    CreateListingMoreOptionsButton.addEventListener('click', () => {
      CreateListingOptionalMoreDescriptionSection.style.display = 'flex'
      CreateListingOptionalCategorySection.style.display = 'flex'
      CreateListingOptionalItemsAvailableSection.style.display = 'flex'
      CreateListingMoreOptionsButton.style.display = 'none'
    })

    CreateListingPriceMoreOptionsButton.addEventListener('click', () => {
      CreateListingOptionsPicPriceMArkedAs.style.display = 'flex'
      CreateListingDiscount.style.display = 'flex'
      CreateListingPriceMoreOptionsCon.style.display = 'none'
    })
  }


  async _initializeCatBrandModelSelects(category = null, brand = null, model = null) {
    try {
      spinner._displaySpinner('Cargando características...');

      const useOptions = [];
      const loadedOptionsDataCategories = await firebase._getMachineData("machineTypes");
      this.#loadedOptionsDataCategories = loadedOptionsDataCategories;

      loadedOptionsDataCategories.forEach(opt => {
        useOptions.push(this._deslug(opt.data.name));
      });

      // Initialize chain
      const chain = this._chainSelects([
        'CreateListingSelectCategory',
        'CreateListingSelectBrand',
        'CreateListingSelectModel'
      ]);

      // Set category options
      chain['CreateListingSelectCategory'].setOptions(useOptions);

      // =========================
      // 🔥 PREFILL LOGIC
      // =========================
      if (category) {
        // 1. Set category
        chain['CreateListingSelectCategory'].setValue(category);

        // 2. Load brands
        const brandOptions = await this._loadOptions([category]);

        chain['CreateListingSelectBrand'].setOptions(brandOptions);
        chain['CreateListingSelectBrand'].enable();

        if (brand) {
          // 3. Set brand
          chain['CreateListingSelectBrand'].setValue(brand);

          // 4. Load models
          const modelOptions = await this._loadOptions([category, brand]);

          chain['CreateListingSelectModel'].setOptions(modelOptions);
          chain['CreateListingSelectModel'].enable();

          if (model) {
            // 5. Set model
            chain['CreateListingSelectModel'].setValue(model);
          }
        }
      }

    } catch (error) {
      console.log(error.message);
    } finally {
      spinner._hideSpinner();
    }
  }

  async _initializeYearSelect(year) {
    const years = GENRALHELPERS._generateYearsArray(1990);
    const useOptions = years.map(y => y.toString());

    const chain = this._chainSelects(['CreateListingSelectYear']);

    const yearSelect = chain['CreateListingSelectYear'];

    yearSelect.setOptions(useOptions);

    // 🔥 PREFILL
    if (year && useOptions.includes(year.toString())) {
      yearSelect.setValue(year.toString());
    }
  }

  async _initializeConditionSelect(condition) {
    const options = ["Nuevo", "Usado"];

    const chain = this._chainSelects(['CreateListingSelectCondition']);

    const conditionSelect = chain['CreateListingSelectCondition'];

    conditionSelect.setOptions(options);

    // 🔥 PREFILL
    if (condition && options.includes(condition)) {
      conditionSelect.setValue(condition);
    }
  }

  // Create a custom select instance
  _createCustomSelect(selectId, options = [], onChange = null) {
    const container = document.getElementById(selectId);
    container.innerHTML = `
    <div class="cs-display">Seleccionar…</div>
    <div class="cs-dropdown">
      <input type="text" class="cs-search" placeholder="Buscar opciones…">
      <div class="cs-options"></div>
    </div>
  `;

    const display = container.querySelector('.cs-display');
    const dropdown = container.querySelector('.cs-dropdown');
    const search = container.querySelector('.cs-search');
    const optionsCon = container.querySelector('.cs-options');

    let currentOptions = [...options];
    let selectedValue = null;
    let isDisabled = false; // NEW

    function renderOptions(filter = "") {
      optionsCon.innerHTML = "";
      const filtered = currentOptions.filter(o =>
        o.toLowerCase().includes(filter.toLowerCase())
      );

      filtered.forEach(opt => {
        const div = document.createElement("div");
        div.className = "cs-option";
        div.textContent = opt;
        div.onclick = () => {
          if (isDisabled) return; // NEW
          selectedValue = opt;
          display.textContent = opt;
          dropdown.style.display = "none";
          if (onChange) onChange(opt);
        };
        optionsCon.appendChild(div);
      });

      if (filter.length > 0 && !currentOptions.includes(filter)) {
        const createDiv = document.createElement("div");
        createDiv.className = "cs-create-option";
        createDiv.textContent = `Agregar "${filter}"`;
        createDiv.onclick = () => {
          if (isDisabled) return; // NEW
          currentOptions.push(filter);
          selectedValue = filter;
          display.textContent = filter;
          dropdown.style.display = "none";
          if (onChange) onChange(filter);
        };
        optionsCon.appendChild(createDiv);
      }
    }

    // Toggle dropdown
    display.onclick = () => {
      if (isDisabled) return; // NEW
      dropdown.style.display =
        dropdown.style.display === "block" ? "none" : "block";
      search.value = "";
      renderOptions("");
    };

    search.oninput = () => {
      if (isDisabled) return; // NEW
      renderOptions(search.value);
    };

    document.addEventListener("click", (e) => {
      if (!container.contains(e.target)) dropdown.style.display = "none";
    });

    return {
      setOptions(newOptions) {
        currentOptions = [...newOptions];
        renderOptions("");
      },
      reset() {
        selectedValue = null;
        display.textContent = "Seleccionar…";
        search.value = "";
        renderOptions("");
      },

      // >>> NEW: DISABLE SELECT <<<
      disable() {
        isDisabled = true;
        container.classList.add("cs-disabled");
        dropdown.style.display = "none";
      },

      // >>> NEW: ENABLE SELECT <<<
      enable() {
        isDisabled = false;
        container.classList.remove("cs-disabled");
      },

      getValue() {
        return selectedValue;
      },
      setValue(value, trigger = true) {
        selectedValue = value;
        display.textContent = value;

        if (trigger && onChange) {
          onChange(value);
        }
      },
    };
  }
  _chainSelects(selectIds) {
    const selects = {};

    // Initialize selects
    selectIds.forEach(id => {
      selects[id] = this._createCustomSelect(
        id,
        [],
        (value) => handleChange(id, value)
      );
    });

    // Disable all except the first
    selectIds.forEach((id, index) => {
      if (index !== 0) selects[id].disable();
    });

    const handleChange = (changedId, value) => {
      const index = selectIds.indexOf(changedId);

      // Reset + disable all after
      for (let i = index + 1; i < selectIds.length; i++) {
        selects[selectIds[i]].reset();
        selects[selectIds[i]].setOptions([]);
        selects[selectIds[i]].disable();
      }

      // Enable + populate next select
      const nextId = selectIds[index + 1];
      if (nextId) {
        const selectedValues = selectIds
          .slice(0, index + 1)
          .map(id => selects[id].getValue());

        this._loadOptions(selectedValues).then(options => {
          selects[nextId].setOptions(options);
          selects[nextId].enable();
        });
      }



      // 👉 Save the actual selected value:
      this._storeSelectedValue(changedId, value.toLowerCase());


      this._checkIfNewCategory(value, changedId);

    };

    return selects;
  }


  _checkIfNewCategory(value, changedId) {
    console.log(value);

    let loadedData = null
    const categoryName = value
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-');

    if (changedId === 'CreateListingSelectCategory') {
      loadedData = this.#loadedOptionsDataCategories
    } else if (changedId === 'CreateListingSelectBrand') {
      loadedData = this.#loadedOptionsDataBrands
    } else if (changedId === 'CreateListingSelectModel') {
      loadedData = this.#loadedOptionsDataModels
    } else {
      return
    }

    const exists = loadedData.some(category =>
      category.data.name.toLowerCase() === categoryName
    );

    if (!exists) {
      this.#newType = true;
    }

    console.log(this.#newType);
  }


  async _loadOptions(selectedValues) {

    try {
      spinner._displaySpinner('Cargando carateristicas...')
      const useOptions = []

      if (selectedValues.length === 1) {
        const loadedData = await firebase._getMachineData(
          `machineTypes/${this._cleanText(selectedValues[0])}/brands`
        );
        this.#loadedOptionsDataBrands = loadedData;

        loadedData.forEach(opt => { useOptions.push(this._deslug(opt.data.name)) })
      }
      if (selectedValues.length === 2) {
        const loadedData = await firebase._getMachineData(
          `machineTypes/${this._cleanText(selectedValues[0])}/brands/${this._cleanText(selectedValues[1])}/models`
        );
        this.#loadedOptionsDataModels = loadedData;
        loadedData.forEach(opt => { useOptions.push(this._deslug(opt.data.name)) })
      }
      // You return an array.
      return useOptions;
    } catch (error) {
      console.log(error.message);
    } finally {
      spinner._hideSpinner()
    }
  }

  _storeSelectedValue(id, value) {

    if (id === "CreateListingSelectCategory") {
      listingData.listingMachineType = value
      const CreateListingSelectCategory = document.getElementById('CreateListingSelectCategory')
      CreateListingSelectCategory.classList.remove('CreateListingSelectCategoryRedBorder')
    }
    if (id === "CreateListingSelectBrand") {
      listingData.listingBrand = value
    }
    if (id === "CreateListingSelectModel") {
      listingData.listingModel = value
    }
    if (id === "CreateListingSelectYear") {
      listingData.listingYear = value
    }
    if (id === "CreateListingSelectCondition") {
      listingData.listingCondition = value
    }



    console.log(id, value);
  }
  _cleanText(text) {
    return text
      .toLowerCase()
      // remove accents
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      // replace any non-alphanumeric characters with spaces
      .replace(/[^a-z0-9]+/g, "-")
      // remove starting/ending hyphens
      .replace(/^-+|-+$/g, "");
  }
  _deslug(text) {
    if (!text) return "";

    return text
      .replace(/-/g, " ")            // dashes → spaces
      .trim()
      .split(/\s+/)                  // split into words
      .map(w => w.charAt(0).toUpperCase() + w.slice(1)) // capitalize
      .join(" ");
  }

  _confirmLeaveListing() {
    return new Promise((resolve) => {

      const modal = document.getElementById('confirmLeaveListingConMain');
      const saveBtn = document.getElementById('confirmLeaveListingButtonSave');
      const leaveBtn = document.getElementById('confirmLeaveListingButtonLeave');
      const cancelBtn = document.getElementById('confirmLeaveListingButtonCancel');

      if (!modal || !saveBtn || !leaveBtn || !cancelBtn) {
        resolve('cancel');
        return;
      }

      modal.style.display = 'flex';

      const cleanup = () => {
        saveBtn.removeEventListener('click', handleSave);
        leaveBtn.removeEventListener('click', handleLeave);
        cancelBtn.removeEventListener('click', handleCancel);

        modal.style.display = 'none';
      };

      const handleSave = () => {
        cleanup();
        resolve('save');
      };

      const handleLeave = () => {
        cleanup();
        resolve('leave');
      };

      const handleCancel = () => {
        cleanup();
        resolve('cancel');
      };

      saveBtn.addEventListener('click', handleSave);
      leaveBtn.addEventListener('click', handleLeave);
      cancelBtn.addEventListener('click', handleCancel);

    });
  }
  _confirmContinueListing() {
    return new Promise((resolve) => {

      const modal = document.getElementById('confirmContinueListingConMain');
      const newBtn = document.getElementById('confirmContinueListingButtonNew');
      const seeDraftsBtn = document.getElementById('confirmContinueListingButtonSeeDrafts');
      const cancelBtn = document.getElementById('confirmContinueListingButtonCancel');
      const continueBtn = document.getElementById('confirmContinueListingButtonContinue');

      if (!modal || !newBtn || !seeDraftsBtn || !cancelBtn || !continueBtn) {
        resolve('cancel');
        return;
      }

      modal.style.display = 'flex';

      const cleanup = () => {
        newBtn.removeEventListener('click', handleNew);
        seeDraftsBtn.removeEventListener('click', handleSeeDrafts);
        cancelBtn.removeEventListener('click', handleCancel);
        continueBtn.removeEventListener('click', handleContinue);

        modal.style.display = 'none';
      };

      const handleNew = () => {
        cleanup();
        resolve('new');
      };

      const handleSeeDrafts = () => {
        cleanup();
        resolve('seeDrafts');
      };

      const handleCancel = () => {
        cleanup();
        resolve('cancel');
      }
      const handleContinue = () => {
        cleanup();
        resolve('continue');
      };

      newBtn.addEventListener('click', handleNew);
      seeDraftsBtn.addEventListener('click', handleSeeDrafts);
      cancelBtn.addEventListener('click', handleCancel);
      continueBtn.addEventListener('click', handleContinue);

    });
  }


  _confirmSelectListingCategoryCreateLiting() {
    return new Promise((resolve) => {

      const modal = document.getElementById('selectListingCategoryCreateLiting');
      const btnOk = document.getElementById('selectListingCategoryCreateLitingOk');

      if (!modal || !btnOk) {
        resolve('cancel');
        return;
      }

      modal.style.display = 'flex';

      const cleanup = () => {
        btnOk.removeEventListener('click', handleOk);
        modal.style.display = 'none';
      };

      const handleOk = () => {
        cleanup();
        resolve('Ok');
      };

      btnOk.addEventListener('click', handleOk);

    });
  }

  async _cancelCreateListing(noDraft = false, tab = 'listing-drafts') {

    let hasChanges = false;
    hasChanges = this.#hasChanges

    console.log(this.#hasChanges);

    if (
      JSON.stringify(listingDataEmpty) !==
      JSON.stringify(listingData)
    ) {
      hasChanges = true;
    }

    if (!hasChanges) {
      const con = document.getElementById(
        `SearchStartUpComponentAllCon`
      );
      con.remove();
      return
    }

    if (this.#isInEdit) {
      const con = document.getElementById(
        `SearchStartUpComponentAllCon`
      );
      con.remove();
      return
    }


    if (noDraft) {
      // const con = document.getElementById(
      //   `SearchStartUpComponentAllCon`
      // );
      // con.remove();
      return
    }

    const action = await this._confirmLeaveListing();
    const modal = document.getElementById('confirmLeaveListingConMain');

    if (action === 'save') {
      modal.style.display = 'none';
      const dataStored = await this._saveDraft()
      nav._init('Activity')
      busineOwn._init(tab);
      console.log(dataStored);


      modal.style.display = 'none';
      const con = document.getElementById(
        `SearchStartUpComponentAllCon`
      );
      con.remove();
    }

    if (action === 'leave') {
      modal.style.display = 'none';
      const con = document.getElementById(
        `SearchStartUpComponentAllCon`
      );
      con.remove();
    }

    if (action === 'cancel') {
      modal.style.display = 'none';
    }

  }

  async _handleSelectPublishProfile(selected) {
    this.#finalPublishListingButtonActivated = false

    console.log(this.#isInEdit);
    function setObjectToLocalStorage(key, value) {
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch (err) {
        console.error('Error saving to localStorage:', err);
      }
    }
    function getObjectFromLocalStorage(key) {
      try {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
      } catch (err) {
        console.error('Error reading from localStorage:', err);
        return null;
      }
    }

    try {
      let publishIn = getObjectFromLocalStorage('lastPublishProfile')

      // Check the listing form validity
      const isValid = this._checkForm()
      // const isValid = true


      if (!isValid) { throw new Error("Completa todos los campos requeridos antes de continuar.") }

      // Select DOM elements
      const SelectPublishProfileCon1ButtonBack = document.getElementById(
        "CreateListingBtnBack"
      );
      const SelectPublishProfileCon1ButtonPublish = document.getElementById(
        "CreateListingBtnPublishNow"
      );
      const SelectPublishProfileCon1 = document.getElementById(
        "SelectPublishProfileCon1"
      );




      const loadProfilesToPublishIn = async () => {
        spinner._displaySpinner('Cargando perfiles para publicar...')
        console.log("Loading profiles to publish in...");
        const SelectPublishProfileConProfile = document.getElementById("SelectPublishProfileConProfile")
        const SelectPublishProfileConBusinesses = document.getElementById("SelectPublishProfileConBusinesses")
        SelectPublishProfileConProfile.innerHTML = ''
        SelectPublishProfileConBusinesses.innerHTML = ''

        const userData = firebase._getLatestCurrentUserData();
        if (!userData) {
          throw new Error("No hemos podido cargar tu cuenta en este momento. Intente de nuevo mas al rato.")
        }

        let activeOnProfile = false

        if (publishIn?.type === 'profile') {
          activeOnProfile = true
        }

        let imageForSellerProfileUse = ''
        if (userData?.profileImages?.[0]?.res_200) {
          imageForSellerProfileUse = userData?.profileImages?.[0]?.res_200
        } else {
          imageForSellerProfileUse = userData.profileImageUrl
        }

        console.log(userData);

        const profile =
          GenerateHTML._returProfileHTML(
            { act: activeOnProfile, type: 'profile', name: userData.userName, description: 'Vendedor', photoURL: imageForSellerProfileUse, id: userData.userId, role: 'Usuario' }, userData
          );
        console.log('profile here', profile);
        SelectPublishProfileConProfile.insertAdjacentHTML("beforeend", profile);
        console.log('profile here');


        // if (0 > 0) {
        if (userData?.businesses?.length > 0) {
          for (const business of userData.businesses) {


            const loadedBusinessData = await firebase._getAnyDocById(`businesses/${business.id}`)
            if (!loadedBusinessData) {
              throw new Error("No hemos podido cargar tu negocio en este momento. Intenta de nuevo mas tarde.")
            }

            let image = ''
            let role = ''


            if (business.role === 'admin') {
              role = 'Admin'
            }
            if (business.role === 'owner') {
              role = 'Propio'
            }
            if (business.role === 'manager') {
              role = 'Gerente'
            }

            console.log('loadedBusinessData', loadedBusinessData);

            if (!loadedBusinessData?.images?.profile[0]?.res_200) {
              image = loadedBusinessData.profileImg
            } else {
              image = loadedBusinessData.images?.profile[0]?.res_200
            }

            let activeOnBusiness = false

            if (publishIn?.businessId === loadedBusinessData.businessId) {
              activeOnBusiness = true
            }

            const businessHtml =
              GenerateHTML._returProfileHTML(
                { act: activeOnBusiness, type: 'business', name: loadedBusinessData.name, description: loadedBusinessData.shortDescription, photoURL: image, id: loadedBusinessData.businessId, role: role, businessId: loadedBusinessData.businessId }, userData
              );
            SelectPublishProfileConBusinesses.insertAdjacentHTML("beforeend", businessHtml);
            spinner._hideSpinner()

          }

        } else {
          const noBusinessHtml =
            GenerateHTML._returNoProfileHTML();
          SelectPublishProfileConBusinesses.insertAdjacentHTML("beforeend", noBusinessHtml);
        }
        spinner._hideSpinner()
      }


      const handleSelectPublishProfile = () => {
        const profiles = document.querySelectorAll(
          '#SelectPublishProfileConProfile .nvSelectPublishProfileProfileCon1, ' +
          '#SelectPublishProfileConBusinesses .nvSelectPublishProfileProfileCon1'
        );

        console.log('profiles', profiles);


        profiles.forEach(profile => {
          console.log('profile here');
          profile.addEventListener('click', () => {
            console.log('profile here');
            // remove active from all
            profiles.forEach(p =>
              p.classList.remove('nvSelectPublishProfileProfileCon1Act')
            );
            console.log('profile here');

            // activate clicked one
            profile.classList.add('nvSelectPublishProfileProfileCon1Act');
            const publishData = { type: profile.dataset.type, sellerId: profile.dataset.sellerid, businessId: profile.dataset.businessid };
            publishIn = publishData;

            console.log('publishIn', publishIn);

            setObjectToLocalStorage('lastPublishProfile', publishData);

          });
        });
      };
      // await loadProfilesToPublishIn()
      // handleSelectPublishProfile();
      if (!this.#isInEdit) {
        SelectPublishProfileCon1.style.display = "flex";
        await loadProfilesToPublishIn()
        handleSelectPublishProfile();
      } else {

        let publishInSend = {
          type: 'profile',
          sellerId: listingData?.sellerId || '',
          businessId: listingData?.businessId || '',
        }
        if (listingData?.businessId) {
          publishInSend = {
            type: 'business',
            sellerId: listingData?.sellerId || '',
            businessId: listingData?.businessId || '',
          }
        }

        await this._publishNow(publishInSend);


        allHandeling._actionsOnListingInEditElement('edit', publishInSend.sellerId, publishInSend.businessId, this.#listingId)


      }




      // Event listener for the "Back" button
      SelectPublishProfileCon1ButtonBack.addEventListener("click", () => {
        SelectPublishProfileCon1.style.display = "none";
      });

      // Event listener for the "Publish" button
      if (this.#finalPublishListingButtonActivated) return
      this.#finalPublishListingButtonActivated = true
      SelectPublishProfileCon1ButtonPublish.addEventListener("click", () => {

        const diference = Date.now() - this.#publishNowButtonFinalClickedAt;

        if (diference < 2000) return
        this.#publishNowButtonFinalClickedAt = Date.now();

        spinner._displaySpinner('Publicando listado...')
        console.log(publishIn);
        if (!publishIn) {
          throw new Error("Selecciona un perfil para publicar el listado.")
        }
        if (!publishIn.type) {
          throw new Error("En este momento hay un error al intentar publicar en este perfile. Favor intenta con otro perfil.")
        }
        if (!publishIn.sellerId && !publishIn.businessId) {
          throw new Error("En este momento hay un error al intentar publicar en este perfile. Favor intenta con otro perfil.")
        }
        this._publishNow(publishIn);
      });
    } catch (error) {
      // console.error(error.message);
      alert(error.message);
    } finally {

      const CreateListingBtnCreateBusiness = document.getElementById('CreateListingBtnCreateBusiness')
      const SelectPublishProfileCon1 = document.getElementById(
        "SelectPublishProfileCon1"
      );

      if (CreateListingBtnCreateBusiness) {

        CreateListingBtnCreateBusiness.addEventListener('click', () => {
          SelectPublishProfileCon1.style.display = "none";
          this._cancelCreateListing(false, 'businesses');

        })
      }


      spinner._hideSpinner();
    }
  }


  async _publishNow(publishIn) {

    this.#isStillUploadingImages = true
    console.log('publishing now in', publishIn);
    console.log('publishing now data', listingData);
    if (publishIn?.type !== 'profile' && listingData?.listingMachineType?.length < 1) {
      const resultOk = await this._confirmSelectListingCategoryCreateLiting();
      console.log(resultOk);

      // Logic of going back, opening advanced options, and scrolling to categories
      if (resultOk === 'Ok') {
        // User confirmed, proceed with the action

        const SelectPublishProfileCon1 = document.getElementById(
          "SelectPublishProfileCon1"
        );
        SelectPublishProfileCon1.style.display = "none";

        const CreateListingMoreOptionsButton = document.getElementById('CreateListingMoreOptionsButton')
        CreateListingMoreOptionsButton.click()

        const CreateListingSelectCategory = document.getElementById('CreateListingSelectCategory')
        CreateListingSelectCategory.classList.add('CreateListingSelectCategoryRedBorder')

        CreateListingSelectCategory?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest'
        });

        spinner._hideSpinner()
        return
      } else {
        // User canceled, handle accordingly
        return
      }

    }
    spinner._hideSpinner();

    try {
      let adminImgPath = `public/accounts/${publishIn.sellerId}/listings`;

      if (publishIn.type === 'business') {
        adminImgPath = `public/businesses/${publishIn.businessId}/listings`;
      }

      // Testing live upload in drafts.

      const dataStored = await this._saveDraft(null, 'uploading')
      console.log(dataStored);


      // this._cancelCreateListing(true);
      nav._init('Activity')
      busineOwn._init('listing-drafts');

      setTimeout(async () => {
        // Spinner._displaySpinner("Subiendo imágenes");
        this.#isStillUploadingImages = true
        const imgs = await FireBaseHelperOwn._uploadImagesAndGetReferences(
          "uploaded-images-container", `${dataStored.prefixId}imageProgressDisplay`, null, 'public/tempUploads/'
        );
        this.#isStillUploadingImages = false

        // listingData.listingMainImg = imgs[0];
        listingData.listingImgsIds = imgs;
        console.log(listingData);
        console.log(imgs);
        // Spinner._hideSpinner()
        // return
        // Spinner._displaySpinner("Creando listado");
        let metaData = {
          publishIn: publishIn,
          isInEdit: this.#isInEdit,
          id: this.#listingId,
          createdAt: this.#listingCreatedAt,
          updatedAt: this.#listingUpdatedAt,
          newType: this.#newType,
          newPlace: this.#newPlace,
          adminImgPath: adminImgPath,
          status: settings._getAppUploadStatus()
        };
        let dataToSend = {
          listingData: listingData,
          metaData: metaData,
        };
        console.log(dataToSend);

        // return
        const resultUploadListing = await firebase._NvUploadNewListing(
          dataToSend
        );
        console.log(resultUploadListing);

        if (resultUploadListing.data.success) {

          // console.log("Listing uploaded successfully. Should open listing now, and trigger CTA share.");
          // let lives = 'seller'
          // let from = 'seller'
          // if (publishIn.type !== 'profile') {
          //   lives = 'business'
          // }


          // Spinner._displaySpinner("Abriendo listado");
          // let useId = publishIn?.businessId || publishIn?.sellerId || ''


          // await allHandeling._displayTheRightWay(useId, resultUploadListing.data.listingId, lives, 'publish', false, "aspectRatio_9-6", true)
          // this._cancelCreateListing();
          this._deleteDraft(dataStored.prefixId)

          const con = document.getElementById(
            `${dataStored.prefixId}actiListingDraftCon1A`
          );
          if (con) con.remove();

        } else {
          alert(
            `Hubo un error al subir este listado. Error: ${resultUploadListing.data.message}`
          );
        }
      }, 200)
      this.#isStillUploadingImages = false
    } catch (error) {
      //error log should be removed for production
      console.error("Image upload failed:", error.message);
      alert(error.message);
    } finally {
      Spinner._hideSpinner();
    }
  }


  _setVideoStatus(status) {

    console.log(status);

    const CreateListingVideoURL = document.getElementById('CreateListingVideoURL');

    if (status) {
      listingData.videoUrl = CreateListingVideoURL.value.trim();
      const CreateListingImagesCon5C1 = document.getElementById('CreateListingImagesCon5C1')
      CreateListingImagesCon5C1.style.display = 'flex'
    } else {
      listingData.videoUrl = '';
    }
  }

  _events(prefixId) {


    if (this.#eventsInitialized) return;
    this.#eventsInitialized = true;


    window.addEventListener("click", (e) => {
      const isVideoSectionOpenButton = e.target.closest(`#upload-trigger-video`)
      const isVideoDeleteButton = e.target.closest(`#CreateListingVideoURLDeleteVideoButton`)
      if (isVideoSectionOpenButton) {

        this._vidInputShowToggler(true)
      }
      if (isVideoDeleteButton) {
        const video = e.target.closest(`.nvV1CreateListignPreviewVidCon2`)

        if (video) {
          listingData.videoUrl = '';
          video.remove()

          const CreateListingVideoURL = document.getElementById('CreateListingVideoURL')

          CreateListingVideoURL.value = ''

          const CreateListingImagesCon5C1 = document.getElementById('CreateListingImagesCon5C1')
          CreateListingImagesCon5C1.style.display = 'none'
        }
      }

    })




    const CreateListingBtnPublish = document.getElementById(
      "CreateListingBtnPublish"
    );
    const CreateListingBtnPublishP = CreateListingBtnPublish.querySelector('p');
    const CreateListingBtnCancel = document.getElementById(
      "CreateListingBtnCancel"
    );
    const CreateListingSelectCategory = document.getElementById(
      `CreateListingSelectCategory`
    );
    const CreateListingSelectBrand = document.getElementById(
      `CreateListingSelectBrand`
    );
    const CreateListingSelectModel = document.getElementById(
      `CreateListingSelectModel`
    );
    const CreateListingSelectYear = document.getElementById(
      `CreateListingSelectYear`
    );
    const CreateListingSelectCondition = document.getElementById(
      `CreateListingSelectCondition`
    );

    const CreateListingName = document.getElementById(
      `CreateListingName`
    );
    const CreateListingVideoURL = document.getElementById(
      `CreateListingVideoURL`
    );
    const CreateListingPrice = document.getElementById(
      `CreateListingPrice`
    );
    const CreateListingItemsAvailable = document.getElementById(
      `CreateListingItemsAvailable`
    );
    const CreateListingDiscountPercent = document.getElementById(
      `CreateListingDiscountPercent`
    );
    const CreateListingDiscountAmount = document.getElementById(
      `CreateListingDiscountAmount`
    );
    const CreateListingDiscountFinalPrice = document.getElementById(
      `CreateListingDiscountFinalPrice`
    );
    const CreateLisitngDescription = document.getElementById(
      `CreateListingDescription`
    );
    const CreateListingAdminNotes = document.getElementById(
      `CreateListingAdminNotes`
    );
    const CreateListingVideoURLPasteFromClipBoardButton = document.getElementById(
      `CreateListingVideoURLPasteFromClipBoardButton`
    );
    const CreateListingVideoURLPreviewVideoButton = document.getElementById(
      `CreateListingVideoURLPreviewVideoButton`
    );
    const CreateListingVideoURLCloseVideoButton = document.getElementById(
      `CreateListingVideoURLCloseVideoButton`
    );
    const nvCreateNewListingButtonOpenLocationSelector = document.getElementById(
      `nvCreateNewListingButtonOpenLocationSelector`
    );
    const CreateListingLocationUseMyLocationButton = document.getElementById(
      `CreateListingLocationUseMyLocationButton`
    );



    nvCreateNewListingButtonOpenLocationSelector.addEventListener('click', async (e) => {

      try {

        e.target.closest(".CreateListingCon2").querySelector(
          ".CreateListingErrorMessage"
        ).textContent = "";
        const locationData = await GENRALHELPERS._locationPicker(listingData.place)

        const locationTag = document.getElementById('nvCreateNewListingButtonOpenLocationSelectorLocationTag')
        locationTag.textContent = GENRALHELPERS._getDisplayLocationName(locationData)

        listingData.place.lat = locationData.lat;
        listingData.place.lng = locationData.lng;
        listingData.place.state = locationData.state;
        listingData.place.country = locationData.country;
        listingData.place.city = locationData.city;
        listingData.place.locationUrl = locationData.locationUrl;
        listingData.place.name = locationData.name;
        listingData.place.address = locationData.address;

        listingData.filterLat = locationData.lat;
        listingData.filterLng = locationData.lng;
        listingData.filterState = locationData.state;
        listingData.filterCountry = locationData.country;
        listingData.filterCity = locationData.city;
        listingData.filterGeoHash = GENRALHELPERS._geoHash(locationData.lat, locationData.lng)

        this.#newPlace = true

        console.log('LocationData', locationData, 'listingData', listingData);

      } catch (error) {
        console.log(error);


        if (error === 'cancelled') {
          if (listingData?.filterLng) {
            console.log('here A');
            console.log(listingData);
            if (listingData?.filterLng?.length < 1) {
              console.log('here A');
              e.target.closest(".CreateListingCon2").querySelector(
                ".CreateListingErrorMessage"
              ).textContent = "La ubicación es obligatoria. Por favor selecciona la ubicación."
            }
          } else {
            console.log('here A');
            console.log(listingData);
            e.target.closest(".CreateListingCon2").querySelector(
              ".CreateListingErrorMessage"
            ).textContent = "La ubicación es obligatoria. Por favor selecciona la ubicación."
          }

        }
      }
    })

    CreateListingLocationUseMyLocationButton.addEventListener('click', async (e) => {

      try {

        e.target.closest(".CreateListingCon2").querySelector(
          ".CreateListingErrorMessage"
        ).textContent = "";

        const locationTag = document.getElementById('nvCreateNewListingButtonOpenLocationSelectorLocationTag')
        locationTag.textContent = 'Cargando...';

        const locationData = await GENRALHELPERS._getCurrentLocation()

        locationTag.textContent = GENRALHELPERS._getDisplayLocationName(locationData)

        listingData.place.lat = locationData.lat;
        listingData.place.lng = locationData.lng;
        listingData.place.state = locationData.state;
        listingData.place.country = locationData.country;
        listingData.place.city = locationData.city;
        listingData.place.locationUrl = locationData.locationUrl;
        listingData.place.name = locationData.name;
        listingData.place.address = locationData.address;

        listingData.filterLat = locationData.lat;
        listingData.filterLng = locationData.lng;
        listingData.filterState = locationData.state;
        listingData.filterCountry = locationData.country;
        listingData.filterCity = locationData.city;
        listingData.filterGeoHash = GENRALHELPERS._geoHash(locationData.lat, locationData.lng)

        this.#newPlace = true

        console.log('LocationData', locationData, 'listingData', listingData);

      } catch (error) {
        console.log(error);


        if (error === 'cancelled') {
          if (listingData?.filterLng) {
            console.log('here A');
            console.log(listingData);
            if (listingData?.filterLng?.length < 1) {
              console.log('here A');
              e.target.closest(".CreateListingCon2").querySelector(
                ".CreateListingErrorMessage"
              ).textContent = "La ubicación es obligatoria. Por favor selecciona la ubicación."
            }
          } else {
            console.log('here A');
            console.log(listingData);
            e.target.closest(".CreateListingCon2").querySelector(
              ".CreateListingErrorMessage"
            ).textContent = "La ubicación es obligatoria. Por favor selecciona la ubicación."
          }

        }
      }
    })



    CreateListingVideoURLPreviewVideoButton.addEventListener('click', () => {
      const CreateListingVideoURL = document.getElementById('CreateListingVideoURL')

      CreateListingVideoURL.focus()
      CreateListingVideoURL.blur()
    })
    CreateListingVideoURLCloseVideoButton.addEventListener('click', () => {
      this._vidInputShowToggler(false)
    })

    CreateListingVideoURLPasteFromClipBoardButton.addEventListener('click', () => {
      this._pasteClipboardToInput('CreateListingVideoURL')
    })


    const SearchStartUpComponentAllCon = document.getElementById(
      `SearchStartUpComponentAllCon`
    );



    const pickerActivate = (id, picker, preset) => {
      let currentPicked = preset;
      const CreateListingMarkItemAsCon = document.getElementById(id);
      const markedCons = CreateListingMarkItemAsCon.querySelectorAll(
        ".CreateListingOptionsPicCon3"
      );

      const errorMessage = document.getElementById(
        `CreateListingErrorMessageCoin`
      );

      const setPicked = (setTo) => {
        markedCons.forEach((con) => {
          if (con.dataset.picked === setTo) {
            con.classList.add("CreateListingOptionsPicCon3Active");
          } else {
            con.classList.remove("CreateListingOptionsPicCon3Active");
          }
        });
        if (picker === "markItemAs") {
          listingData.listingMarkedAs = setTo;
        }
        if (picker === "markPriceAs") {
          listingData.listingPriceMarkedAs = setTo;

          const priceCon = document.getElementById(
            `CreateListingPrice`
          );
          const coinCon = document.getElementById(
            `CreateListingCoin`
          );
          const discountCon = document.getElementById(
            `CreateListingDiscount`
          );

          if (setTo === "preguntar") {
            priceCon.style.opacity = ".3";
            coinCon.style.opacity = ".3";
            discountCon.style.opacity = ".3";
          } else {
            priceCon.style.opacity = "1";
            coinCon.style.opacity = "1";
            discountCon.style.opacity = "1";
          }
        }
        if (picker === "priceCoin") {
          listingData.listingCoin = setTo;
          CreateListingPrice.closest(
            ".CreateListingOptionsInputCon2"
          ).querySelector(".CreateListingErrorMessage").textContent = "";
        }
      };
      setPicked(preset);

      CreateListingMarkItemAsCon.addEventListener("click", (e) => {
        const closestMarked = e.target.closest(".CreateListingOptionsPicCon3");
        if (!closestMarked) return;
        if (errorMessage) {
          errorMessage.textContent = "";
        }
        const markedClicked = closestMarked.dataset.picked;

        if (currentPicked === markedClicked) {
          markedCons.forEach((con) => {
            con.classList.remove("CreateListingOptionsPicCon3Active");
          });
          setPicked("");
          currentPicked = "";
          if (picker === "markItemAs") {
            listingData.listingMarkedAs = "";
          }
          if (picker === "markPriceAs") {
            listingData.listingPriceMarkedAs = "";
          }
          if (picker === "priceCoin") {
            listingData.listingCoin = "";
          }
          return;
        }

        setPicked(markedClicked);
        currentPicked = markedClicked;
      });
    };
    pickerActivate(
      "CreateListingCoinPic",
      "priceCoin",
      listingData.listingCoin
    );
    pickerActivate(
      "CreateListingPicMarkPrice",
      "markPriceAs",
      listingData.listingPriceMarkedAs
    );
    pickerActivate(
      "CreateListingMarkItemAsCon",
      "markItemAs",
      listingData.listingMarkedAs
    );
    console.log('listingData.listingMarkedAs', listingData.listingMarkedAs);

    // this._imageHandle(listingData.listingImgsIds);

    // TODO find out why the button do not work after reload.


    if (this.#isInEdit) {
      CreateListingBtnPublishP.textContent = "Actualizar Listado";
    } else {
      CreateListingBtnPublishP.textContent = "Publicar Gratis";
    }

    CreateListingBtnPublish.addEventListener("click", async () => {
      // GENRALHELPERS._stopTimer('createListingInit')

      console.log(listingData);
      console.log('here');
      this._handleSelectPublishProfile();
      // this._handleListingPublish();
    });
    CreateListingBtnCancel.addEventListener("click", () => {
      this._cancelCreateListing();
    });

    CreateListingSelectCategory.addEventListener('click', () => {
      CreateListingSelectCategory.closest(".nvCreateNewListingCustomSelectCon1").querySelector(
        ".CreateListingErrorMessage"
      ).textContent = "";
    })
    CreateListingSelectBrand.addEventListener('click', () => {
      CreateListingSelectBrand.closest(".nvCreateNewListingCustomSelectCon1").querySelector(
        ".CreateListingErrorMessage"
      ).textContent = "";
    })
    CreateListingSelectModel.addEventListener('click', () => {
      CreateListingSelectModel.closest(".nvCreateNewListingCustomSelectCon1").querySelector(
        ".CreateListingErrorMessage"
      ).textContent = "";
    })
    CreateListingSelectYear.addEventListener('click', () => {
      CreateListingSelectYear.closest(".nvCreateNewListingCustomSelectCon1").querySelector(
        ".CreateListingErrorMessage"
      ).textContent = "";
    })
    CreateListingSelectCondition.addEventListener('click', () => {
      CreateListingSelectCondition.closest(".nvCreateNewListingCustomSelectCon1").querySelector(
        ".CreateListingErrorMessage"
      ).textContent = "";
    })








    CreateListingName.addEventListener("keyup", (e) => {
      const targetValue = e.target.value.trim();
      listingData.listingName = targetValue;
      CreateListingName.closest(".CreateListingNameCon1").querySelector(
        ".CreateListingErrorMessage"
      ).textContent = "";
    });
    CreateListingVideoURL.addEventListener("blur", async (e) => {
      const nvV1CreateListignPreviewVidCon1 = document.getElementById('nvV1CreateListignPreviewVidCon1')
      const targetValue = e.target.value.trim();

      const videoInCreateListing = document.getElementById(
        "videoInCreateListing"
      );
      if (videoInCreateListing) {
        videoInCreateListing.remove();
      }

      const videoHTML = GenerateHTML._returnVideoPreviewHTML(targetValue);

      if (videoHTML === "ERROR" || !videoHTML) {
        this.#isValidVideo = false;
        listingData.videoUrl = "";
      } else {

        nvV1CreateListignPreviewVidCon1.innerHTML = "";
        nvV1CreateListignPreviewVidCon1.insertAdjacentHTML(
          "afterbegin",
          videoHTML
        );


        const el = document.querySelector(".nvV1CreateListignPreviewVidCon4");

        if (!el) return;

        if (el.tagName === "VIDEO") {

          el.addEventListener("loadedmetadata", () => {
            console.log("video loaded");
            this._setVideoStatus(true);
          });

          el.addEventListener("error", () => {
            console.log("video failed");
            this._setVideoStatus(false);
          });

        }

        if (el.tagName === "IFRAME") {

          el.addEventListener("load", () => {
            console.log("iframe loaded");
            this._setVideoStatus(true);
          });

        }

        display._videoHandler();
      }
    });

    CreateListingPrice.addEventListener("keyup", (e) => {
      const targetValue = e.target.value;

      // Remove any non-numeric characters except periods
      const extractedNumbers = targetValue.replace(/[^\d.]/g, "");

      // Format the number with thousands separators
      const formattedPrice = formatToPriceWithThousands(extractedNumbers);

      // Update the input value with the formatted price
      e.target.value = formattedPrice;
      listingData.listingPrice = formattedPrice.replace(/,/g, "");
      CreateListingPrice.closest(
        ".CreateListingOptionsInputCon2"
      ).querySelector(".CreateListingErrorMessage").textContent = "";
      discountTakeCare("percent");
    });

    CreateListingItemsAvailable.addEventListener("keyup", (e) => {
      const targetValue = e.target.value;

      // Remove any non-numeric characters except periods
      const extractedNumbers = targetValue.replace(/[^\d.]/g, "");

      // Format the number with thousands separators
      const formattedPrice = formatToPriceWithThousands(extractedNumbers);

      // Update the input value with the formatted price
      e.target.value = formattedPrice;
      listingData.listingItemsAvailable = Number(
        formattedPrice.replace(/,/g, "")
      );

      CreateListingItemsAvailable.closest(
        ".CreateListingOptionsInputCon2"
      ).querySelector(".CreateListingErrorMessage").textContent = "";
    });

    function formatToPriceWithThousands(value) {
      if (!value) return ""; // Handle empty input gracefully
      // Ensure there are no multiple decimals and format to two decimal places
      const parts = value.split(".");
      const integerPart = parts[0].replace(/^0+/, ""); // Remove leading zeros
      const decimalPart = parts[1] ? parts[1].slice(0, 2) : "";

      // Add thousands separators to the integer part
      const formattedInteger = integerPart.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        ","
      );

      return decimalPart
        ? `${formattedInteger}.${decimalPart}`
        : formattedInteger;
    }

    const discountTakeCare = (calculateOn) => {
      const price =
        parseInt(
          CreateListingPrice.value.trim().replace(/,/g, "") // ✅ Removes commas
        ) || 0;
      const discountPercent =
        parseInt(CreateListingDiscountPercent.value.trim().replace(/,/g, "")) ||
        0;
      const discountAmount =
        parseInt(CreateListingDiscountAmount.value.trim().replace(/,/g, "")) ||
        0;
      const finalPrice =
        parseInt(
          CreateListingDiscountFinalPrice.value.trim().replace(/,/g, "")
        ) || 0;

      let calcdiscountPercent = discountPercent;
      let calcdiscountAmount = discountAmount;
      let calcfinalPrice = finalPrice;

      if (calculateOn === "percent") {
        const ad = parseFloat(price * (discountPercent / 100)).toFixed(2);
        calcdiscountAmount = ad;
        calcfinalPrice = parseFloat(price - ad).toFixed(2);

        CreateListingDiscountAmount.value =
          formatToPriceWithThousands(calcdiscountAmount);
        CreateListingDiscountFinalPrice.value =
          formatToPriceWithThousands(calcfinalPrice);
      }
      if (calculateOn === "amount") {
        const pd =
          price !== 0
            ? parseFloat((discountAmount / price) * 100).toFixed(2)
            : 0;
        calcfinalPrice = parseFloat(price - discountAmount).toFixed(2);
        calcdiscountPercent = pd;

        CreateListingDiscountPercent.value =
          formatToPriceWithThousands(calcdiscountPercent);
        CreateListingDiscountFinalPrice.value =
          formatToPriceWithThousands(calcfinalPrice);
      }
      if (calculateOn === "final") {
        const ad = parseFloat(price - finalPrice).toFixed(2);
        calcdiscountAmount = ad;
        const pd = price !== 0 ? parseFloat((ad / price) * 100).toFixed(2) : 0;
        calcdiscountPercent = pd;

        CreateListingDiscountPercent.value =
          formatToPriceWithThousands(calcdiscountPercent);
        CreateListingDiscountAmount.value =
          formatToPriceWithThousands(calcdiscountAmount);
      }

      listingData.onDiscount.finalPrice = parseInt(calcfinalPrice);
      listingData.onDiscount.percent = calcdiscountPercent;
      listingData.onDiscount.amount = parseInt(calcdiscountAmount);

      console.log(listingData);
    };

    const discountEvents = () => {
      CreateListingDiscountPercent.addEventListener("keyup", (e) => {
        const targetValue = e.target.value;
        const extractedNumbers = targetValue.replace(/[^\d.]/g, "");
        e.target.value = extractedNumbers;
        discountTakeCare("percent");
      });
      CreateListingDiscountAmount.addEventListener("keyup", (e) => {
        const targetValue = e.target.value;
        const extractedNumbers = targetValue.replace(/[^\d.]/g, "");
        const formattedPrice = formatToPriceWithThousands(extractedNumbers);
        e.target.value = formattedPrice;
        discountTakeCare("amount");
      });
      CreateListingDiscountFinalPrice.addEventListener("keyup", (e) => {
        const targetValue = e.target.value;
        const extractedNumbers = targetValue.replace(/[^\d.]/g, "");
        const formattedPrice = formatToPriceWithThousands(extractedNumbers);
        e.target.value = formattedPrice;
        discountTakeCare("final");
      });
    };

    discountEvents();

    CreateLisitngDescription.addEventListener("keyup", (e) => {
      const targetValue = e.target.value.trim();
      listingData.listingDescription = targetValue;
      CreateLisitngDescription.closest(
        ".CreateListingDescriptionCon1"
      ).querySelector(".CreateListingErrorMessage").textContent = "";
    });

    CreateListingAdminNotes.addEventListener("keyup", (e) => {
      const targetValue = e.target.value.trim();
      listingData.adminNotes = targetValue;
      CreateListingAdminNotes.closest(
        ".CreateListingDescriptionCon1"
      ).querySelector(".CreateListingErrorMessage").textContent = "";
    });
  }

  async _handleListingPublish() {
    this._handleSelectPublishProfile();
  }

  _checkForm() {
    console.log('here');
    let validForm = true;

    const imagesPresent = this._hasImagesInContainer(
      "uploaded-images-container"
    );
    if (!imagesPresent) {
      const images = document.getElementById(
        "CreateListingErrorMessageImages"
      );
      images.textContent =
        "Agrega unos imágenes a este listado. Puedes agregar hasta 6 imágenes.";
      validForm = false
    }

    if (listingData.listingName === "") {
      const name = document.getElementById(
        "CreateListingErrorMessageName"
      );
      name.textContent = "El titulo no puede estar vacío";
      validForm = false
    } else {
      if (listingData.listingName.length < 8) {
        const name = document.getElementById(
          "CreateListingErrorMessageName"
        );
        name.textContent = "El titulo tiene que ser al menos 8 carácteres";
        validForm = false
      }
    }
    if (listingData?.place?.lat < 1) {
      const location = document.getElementById(
        "CreateListingErrorMessageLocation"
      );
      location.textContent = "La ubicación es obligatorio";
      validForm = false
    }
    if (
      listingData.listingPrice === "" &&
      listingData.listingPriceMarkedAs !== "preguntar"
    ) {
      const price = document.getElementById(
        "CreateListingErrorMessagePrice"
      );
      price.textContent = "Ponle un precio a este listado";
      validForm = false
    }
    if (
      listingData.listingCoin === "" &&
      listingData.listingPriceMarkedAs !== "preguntar"
    ) {
      const price = document.getElementById(
        "CreateListingErrorMessagePrice"
      );
      price.textContent = "Selecciona la moneda del precio";
      validForm = false
    }

    // START Optional.
    // if (listingData.listingMachineType === "") {
    //   const machine = document.getElementById(
    //     "CreateListingErrorMessageSelectMachine"
    //   );
    //   machine.textContent = "Seleciona la categoría";
    //   validForm = false
    // }
    // if (listingData.listingBrand === "") {
    //   const brand = document.getElementById(
    //     "CreateListingErrorMessageSelectBrand"
    //   );
    //   brand.textContent = "Seleciona una marca";
    //   validForm = false
    // }
    // if (listingData.listingModel === "") {
    //   const model = document.getElementById(
    //     "CreateListingErrorMessageSelectModel"
    //   );
    //   model.textContent = "Seleciona un modelo";
    //   validForm = false
    // }
    // if (listingData.listingYear === "") {
    //   const year = document.getElementById(
    //     "CreateListingErrorMessageSelectYear"
    //   );
    //   year.textContent = "Seleciona un año";
    //   validForm = false
    // }
    // if (listingData.listingCondition === "") {
    //   const condition = document.getElementById(
    //     "CreateListingErrorMessageSelectCondition"
    //   );
    //   condition.textContent = "Seleciona una condición";
    //   validForm = false
    // }
    // if (listingData.listingDescription === "") {
    //   const description = document.getElementById(
    //     "CreateListingErrorMessageDescription"
    //   );
    //   description.textContent = "Agrega una descripción a este listado. Con más información es mejor.";
    //   validForm = false
    // } else if (listingData.listingDescription.split(" ").length < 8) {
    //   const description = document.getElementById(
    //     "CreateListingErrorMessageDescription"
    //   );
    //   description.textContent = "La descripción tiene que tener a lo menos 8 palabras. Con más información es mejor.";
    //   validForm = false
    // }
    return validForm;
  }

  _hasImagesInContainer(containerId) {
    const imagesContainer = document.getElementById(containerId);

    // Check if the container exists and has any children
    if (!imagesContainer || imagesContainer.children.length === 0) {
      return false;
    }

    return true;
  }
  _vidInputShowToggler(show = false) {
    const CreateListingCon2InputForVidUrl = document.getElementById('CreateListingCon2InputForVidUrl')

    if (show) {
      CreateListingCon2InputForVidUrl.classList.remove('CreateListingCon2Hidden')
    } else {
      CreateListingCon2InputForVidUrl.classList.add('CreateListingCon2Hidden')
    }
  }

  // async _pasteClipboardToInput(inputId) {
  //   const input = document.getElementById(inputId);
  //   if (!input) return;

  //   try {
  //     const text = await navigator.clipboard.readText();

  //     if (!text || text.trim() === "") {
  //       alert("No hay nada en el portapapeles.");
  //       return;
  //     }

  //     input.value = text;


  //     input.focus()
  //     input.blur()

  //   } catch (err) {
  //     alert("No se pudo acceder al portapapeles.");
  //     console.error(err);
  //   }
  // }}



  async _pasteClipboardToInput(inputId) {
    const input = document.getElementById(inputId);
    if (!input) return;

    try {
      let text = '';

      // ✅ 1. Native (Android / iOS)
      if (window.Capacitor?.isNativePlatform?.()) {
        const result = await Clipboard.read();
        text = result?.value || '';

        // ✅ 2. Web
      } else if (navigator.clipboard && navigator.clipboard.readText) {
        text = await navigator.clipboard.readText();

      } else {
        alert("El portapapeles no está disponible en este dispositivo.");
        return;
      }

      if (!text.trim()) {
        alert("No hay nada en el portapapeles.");
        return;
      }

      input.value = text;

      // trigger UI updates if needed
      input.dispatchEvent(new Event('input', { bubbles: true }));

      input.focus();
      input.blur();

    } catch (err) {
      console.error(err);
      alert("No se pudo acceder al portapapeles.");
    }
  }

  _imageHandle(imgsArr) {

    // console.log(imgsArr);

    console.warn("HandleImages is called");

    const createListingImageUploadText1 = document.getElementById(
      "createListingImageUploadText1"
    );

    const CreateListingImageOrganizeMessage = document.getElementById(
      "CreateListingImageOrganizeMessage"
    );

    const CreateListingImagesCon2 = document.getElementById(
      "CreateListingImagesCon2"
    );

    const uploadTrigger = document.getElementById("upload-trigger");
    const fileInput = document.getElementById("image-upload-input");

    const imagesContainer = document.getElementById(
      "uploaded-images-container"
    );

    const MAX_IMAGES = 6;

    fileInput.setAttribute("accept", "image/*");
    fileInput.setAttribute("multiple", "true");

    // uploadTrigger.addEventListener("click", () => {

    //   uploadTrigger
    //     .closest(".CreateListingImagesCon1")
    //     .querySelector(".CreateListingErrorMessage").textContent = "";

    //   if (imagesContainer.children.length >= MAX_IMAGES) {
    //     alert(`You can only upload up to ${MAX_IMAGES} images.`);
    //     return;
    //   }

    //   fileInput.click();

    // });

    uploadTrigger.addEventListener("click", async () => {

      uploadTrigger
        .closest(".CreateListingImagesCon1")
        .querySelector(".CreateListingErrorMessage").textContent = "";

      if (imagesContainer.children.length >= MAX_IMAGES) {
        alert(`Solo es permitido subir ${MAX_IMAGES} imagenes.`);
        return;
      }

      // ✅ Native (Android / iOS)
      // if (window.Capacitor?.isNativePlatform?.()) {
      //   try {

      //     const image = await Camera.getPhoto({
      //       quality: 80,
      //       allowEditing: false,
      //       resultType: CameraResultType.Uri,
      //       source: CameraSource.Prompt,
      //     });

      //     if (!image?.webPath) return;

      //     // 🔥 Convert to File (THIS is the key)
      //     const response = await fetch(image.webPath);
      //     const blob = await response.blob();
      //     const file = new File([blob], `image-${Date.now()}.jpg`, {
      //       type: blob.type,
      //     });

      //     // 🔥 Reuse your existing logic EXACTLY
      //     const reader = new FileReader();

      //     reader.onload = (e) => {
      //       const imageUrl = e.target.result;

      //       const imageDiv = createImageDiv(imageUrl, file.name);
      //       imagesContainer.appendChild(imageDiv);
      //       this.#hasChanges = true;
      //     };

      //     reader.readAsDataURL(file);

      //     createListingImageUploadText1.style.display = 'none'
      //     CreateListingImageOrganizeMessage.classList.remove(
      //       "CreateListingImagesAddImagesTextHidden"
      //     );

      //     CreateListingImagesCon2.style.display = "flex";

      //   } catch (err) {
      //     if (err?.message?.includes("User cancelled")) return;

      //     console.error("Camera error:", err);
      //     alert("No se pudo abrir la cámara o galería.");
      //   }

      // } else {
      //   // ✅ Web stays EXACTLY the same
      //   fileInput.click();
      // }

      // ✅ Native (Android / iOS)
      if (window.Capacitor?.isNativePlatform?.()) {

        try {

          const remainingSlots =
            MAX_IMAGES - imagesContainer.children.length;

          if (remainingSlots <= 0) {
            alert(`Solo es permitido subir ${MAX_IMAGES} imágenes.`);
            return;
          }

          const result = await Camera.pickImages({
            quality: 80,
          });

          if (!result?.photos?.length) return;

          const photosToProcess =
            result.photos.slice(0, remainingSlots);

          for (const image of photosToProcess) {

            if (!image?.webPath) continue;

            const response = await fetch(image.webPath);
            const blob = await response.blob();

            const file = new File(
              [blob],
              `image-${Date.now()}-${Math.random()}.jpg`,
              {
                type: blob.type || "image/jpeg",
              }
            );

            const reader = new FileReader();

            reader.onload = (e) => {

              const imageUrl = e.target.result;

              const imageDiv = createImageDiv(
                imageUrl,
                file.name
              );

              imagesContainer.appendChild(imageDiv);

              this.#hasChanges = true;
            };

            reader.readAsDataURL(file);
          }

          createListingImageUploadText1.style.display = 'none';

          CreateListingImageOrganizeMessage.classList.remove(
            "CreateListingImagesAddImagesTextHidden"
          );

          CreateListingImagesCon2.style.display = "flex";

          if (
            result.photos.length > remainingSlots
          ) {
            alert(
              `Solo se agregaron ${remainingSlots} imágenes porque el máximo es ${MAX_IMAGES}.`
            );
          }

        } catch (err) {

          console.error(
            "Image picker error:",
            err
          );

          if (
            err?.message?.includes("cancel") ||
            err?.message?.includes("User cancelled")
          ) {
            return;
          }

          alert(
            "No se pudo abrir la galería."
          );
        }

      } else {

        // ✅ Web stays EXACTLY the same
        fileInput.click();

      }
    });

    fileInput.addEventListener("change", (event) => {

      const files = Array.from(event.target.files);

      const remainingSlots =
        MAX_IMAGES - imagesContainer.children.length;

      const limitedFiles = files.slice(0, remainingSlots);

      limitedFiles.forEach((file) => {

        if (!file.type.startsWith("image/")) return;

        const reader = new FileReader();

        reader.onload = (e) => {

          const imageUrl = e.target.result;

          const imageDiv = createImageDiv(imageUrl, file.name);

          imagesContainer.appendChild(imageDiv);
          this.#hasChanges = true;

        };

        reader.readAsDataURL(file);

      });

      if (files.length > limitedFiles.length) {

        alert(
          `Seleccionastes ${files.length} imagenes, pero solo ${remainingSlots} mas pueden ser subidos.`
        );

      }

      fileInput.value = "";

      createListingImageUploadText1.style.display = 'none'
      CreateListingImageOrganizeMessage.classList.remove(
        "CreateListingImagesAddImagesTextHidden"
      );

      CreateListingImagesCon2.style.display = "flex";

    });

    const createImageDiv = (imageUrl, fileName) => {

      const imageHtml = `
          <div class="nvV1CreateListignImagesCon1">

            <div class="nvV1CreateListignImagesCon2">
              <img class="nvV1CreateListignImagesCon2B" height="16px" src="${iconWhiteDrag}">
            </div>

            <div class="nvV1CreateListignImagesCon3">
              <div class="nvV1CreateListignImagesCon4">
                <img class="nvV1CreateListignImagesCon4Image uploadSpecific" src="${imageUrl}">
              </div>

              <div class="nvV1CreateListignImagesCon5">

                <div class="nvV1CreateListignImagesText1">${fileName}</div>

                <div class="nvV1CreateListignImagesCon6">

                  <div class="nvV1CreateListignImagesCon7 delete-btn">
                    <div class="nvV1CreateListignImagesText2">Eliminar</div>
                  </div>

                </div>

              </div>

            </div>

          </div>
        `;

      const imageDiv = document.createElement("div");

      imageDiv.classList.add("CreateListingImagesImageCon1");

      imageDiv.setAttribute("draggable", "true");

      imageDiv.innerHTML = imageHtml;

      const img = imageDiv.querySelector(".nvV1CreateListignImagesCon4");

      const deleteBtn = imageDiv.querySelector(".delete-btn");

      img.addEventListener("contextmenu", (e) => {
        e.preventDefault();
      });

      deleteBtn.addEventListener("click", () => {
        imageDiv.remove();
        this.#hasChanges = true;
      });

      return imageDiv;
    }

    /* ---------------- DESKTOP DRAG ---------------- */

    let draggedItem = null;

    imagesContainer.addEventListener("dragstart", (e) => {

      const item = e.target.closest(".CreateListingImagesImageCon1");

      if (!item) return;

      draggedItem = item;

      item.classList.add("dragging");

    });

    imagesContainer.addEventListener("dragend", () => {

      if (draggedItem) draggedItem.classList.remove("dragging");

      draggedItem = null;
      this.#hasChanges = true;

    });

    imagesContainer.addEventListener("dragover", (e) => {

      e.preventDefault();

      const afterElement = getDragAfterElement(
        imagesContainer,
        e.clientY
      );

      if (afterElement == null) {

        imagesContainer.appendChild(draggedItem);

      } else {

        imagesContainer.insertBefore(draggedItem, afterElement);

      }

    });

    let touchItem = null;
    let startY = 0;

    imagesContainer.addEventListener("touchstart", (e) => {

      const item = e.target.closest(".CreateListingImagesImageCon1");

      if (!item) return;

      touchItem = item;

      startY = e.touches[0].clientY;

      item.classList.add("dragging");

    }, { passive: true });


    imagesContainer.addEventListener("touchmove", (e) => {

      if (!touchItem) return;

      e.preventDefault(); // prevents page scroll while dragging

      const touch = e.touches[0];
      const currentY = touch.clientY;

      const afterElement = getDragAfterElement(
        imagesContainer,
        currentY
      );

      if (afterElement == null) {

        imagesContainer.appendChild(touchItem);

      } else {

        imagesContainer.insertBefore(touchItem, afterElement);

      }

    }, { passive: false });


    imagesContainer.addEventListener("touchend", () => {

      if (touchItem) touchItem.classList.remove("dragging");

      touchItem = null;
      this.#hasChanges = true;

    });

    /* ---------------- REORDER HELPER ---------------- */

    function getDragAfterElement(container, y) {

      const draggableElements = [
        ...container.querySelectorAll(
          ".CreateListingImagesImageCon1:not(.dragging)"
        ),
      ];

      return draggableElements.reduce(

        (closest, child) => {

          const box = child.getBoundingClientRect();

          const offset = y - box.top - box.height / 2;

          if (offset < 0 && offset > closest.offset) {

            return { offset: offset, element: child };

          } else {

            return closest;

          }

        },

        { offset: Number.NEGATIVE_INFINITY }

      ).element;

    }


    /* ---------------- LOAD EXISTING IMAGES ---------------- */

    if (Array.isArray(imgsArr) && imgsArr.length) {

      const remainingSlots = MAX_IMAGES - imagesContainer.children.length;

      const limitedImages = imgsArr.slice(0, remainingSlots);

      limitedImages.forEach((img) => {

        const imageDiv = createImageDiv(img, "foto de listado");

        imagesContainer.appendChild(imageDiv);

      });

      if (imagesContainer.children.length > 0) {

        createListingImageUploadText1.style.display = 'none'
        CreateListingImageOrganizeMessage.classList.remove(
          "CreateListingImagesAddImagesTextHidden"
        );

        CreateListingImagesCon2.style.display = "flex";

      }

    }

  }


  _getListingImageArr() {
    return listingData.listingImgsIds
  }


  _eventsForOptions(prefixId) {
    return
    this._setMachineTypes(prefixId);
    this._setMachineYears(prefixId);
    this._setMachineConditions(prefixId);
  }
  // Start Inovation with new selects

  // _initiateSelectOptions = async (
  //   isMultiple,
  //   parrentId,
  //   parrentAllId,
  //   prefixId,
  //   optionsData
  // ) => {
  //   // return
  //   const options = [];
  //   if (!optionsData) {
  //     return;
  //   } else if (!optionsData.length > 0) return;
  //   optionsData.forEach((option) => {
  //     options.push({
  //       id: option.id,
  //       label: GENRALHELPERS._formatReadableString(option.id),
  //     });
  //   });

  //   let selectedValues = [];
  //   let createdOptions = []; // To track options created by the user

  //   const parentAllConEl = document.getElementById(parrentAllId);
  //   const parentConEl = document.getElementById(parrentId);
  //   const selectedOptionsDiv = parentConEl.querySelector(`#selected-options`);
  //   const searchInput = parentConEl.querySelector(`#search-input`);
  //   const optionList = parentConEl.querySelector(`#option-list`);
  //   parentConEl.classList.add("SearchStartUpComponentCon10Clear");

  //   searchInput.addEventListener("click", () => {
  //     searchInput
  //       .closest(".SearchStartUpComponentCon8")
  //       .querySelector(".CreateListingErrorMessage").textContent = "";
  //   });

  //   // Function to render the selected options
  //   const renderSelectedOptions = () => {
  //     selectedOptionsDiv.innerHTML = "";
  //     selectedValues.forEach((value) => {
  //       const option =
  //         options.find((opt) => opt.id === value) ||
  //         createdOptions.find((opt) => opt.id === value);
  //       const optionDiv = document.createElement("div");
  //       optionDiv.classList.add("selected-option");
  //       optionDiv.innerHTML = `${option.label} ${option.isCreated ? "<span class='created-tag'>(Creado)</span>" : ""
  //         } <span class="remove" data-id="${option.id}">x</span>`;
  //       selectedOptionsDiv.appendChild(optionDiv);
  //     });

  //     // Attach remove functionality to each selected option
  //     parentConEl.querySelectorAll(".remove").forEach((removeButton) => {
  //       removeButton.addEventListener("click", (e) => {
  //         const id = e.target.dataset.id;
  //         selectedValues = selectedValues.filter((value) => value !== id);

  //         let Type;

  //         if (parentConEl.id.includes("Type")) {
  //           Type = "Type";

  //           listingData.listingMachineType = "";
  //           listingData.listingBrand = "";
  //           listingData.listingModel = "";
  //         } else if (parentConEl.id.includes("Brand")) {
  //           Type = "Brand";

  //           listingData.listingBrand = "";
  //           listingData.listingModel = "";
  //         } else if (parentConEl.id.includes("Model")) {
  //           Type = "Model";

  //           listingData.listingModel = "";
  //         } else if (parentConEl.id.includes("Year")) {
  //           Type = "Year";
  //           listingData.listingYear = "";
  //         } else if (parentConEl.id.includes("Condition")) {
  //           Type = "Condition";

  //           listingData.listingCondition = "";
  //         }
  //         this._callTheRightFunction(prefixId, Type);

  //         // Log when a value is removed
  //         renderSelectedOptions();
  //         renderOptionList();
  //       });
  //     });
  //   };

  //   // Function to render the option list based on search input
  //   const renderOptionList = () => {
  //     if (parrentId.includes("Brand") && this.#machineBrandsOnCleared) {
  //       return;
  //     }
  //     if (parrentId.includes("Model") && this.#machineModelsOnCleared) {
  //       return;
  //     }
  //     const query = searchInput.value.toLowerCase();
  //     const filteredOptions = options
  //       .concat(createdOptions)
  //       .filter(
  //         (option) =>
  //           option.label.toLowerCase().includes(query) &&
  //           !selectedValues.includes(option.id)
  //       );

  //     optionList.innerHTML = ""; // Clear the current list

  //     if (filteredOptions.length > 0) {
  //       filteredOptions.forEach((option) => {
  //         const optionItem = document.createElement("div");
  //         optionItem.classList.add("option-item");
  //         optionItem.textContent = option.label;
  //         optionItem.addEventListener("click", () => {
  //           if (isMultiple) {
  //             if (!selectedValues.includes(option.id)) {
  //               selectedValues.push(option.id);
  //             }
  //           } else {
  //             selectedValues = [option.id];
  //           }

  //           let Type;

  //           console.log(option.id);

  //           if (parentConEl.id.includes("Type")) {
  //             Type = "Type";
  //             listingData.listingMachineType = option.id;
  //             listingData.listingBrand = "";
  //             listingData.listingModel = "";
  //           } else if (parentConEl.id.includes("Brand")) {
  //             Type = "Brand";
  //             listingData.listingBrand = option.id;
  //             listingData.listingModel = "";
  //           } else if (parentConEl.id.includes("Model")) {
  //             Type = "Model";
  //             listingData.listingModel = option.id;
  //           } else if (parentConEl.id.includes("Year")) {
  //             Type = "Year";
  //             listingData.listingYear = option.id;
  //           } else if (parentConEl.id.includes("Condition")) {
  //             Type = "Condition";
  //             listingData.listingCondition = option.id;
  //           }
  //           this._callTheRightFunction(prefixId, Type);

  //           renderSelectedOptions();
  //           renderOptionList();
  //           searchInput.value = "";
  //         });
  //         optionList.appendChild(optionItem);
  //       });
  //     } else if (query.trim() !== "") {
  //       const createOption = document.createElement("div");
  //       createOption.classList.add("create-option");
  //       createOption.textContent = `Crear nueva opción: "${query.trim()}"`;
  //       createOption.addEventListener("click", () => {
  //         const optionIdForHere = query
  //           .trim()
  //           .toLowerCase()
  //           .split(" ")
  //           .join("-"); // Unique ID for created options
  //         const newOption = {
  //           id: optionIdForHere,
  //           label: GENRALHELPERS._formatReadableString(query.trim()),
  //           isCreated: true,
  //         };
  //         this.#newType = true;
  //         console.log(`User created and selected: ${newOption.label}`); // Log the created and selected value
  //         let Type;

  //         if (parentConEl.id.includes("Type")) {
  //           Type = "Type";
  //           console.log(`User selected: ${optionIdForHere}`);
  //           console.log(`selected: Type`);
  //           listingData.listingMachineType = optionIdForHere;
  //           listingData.listingBrand = "";
  //           listingData.listingModel = "";
  //         } else if (parentConEl.id.includes("Brand")) {
  //           Type = "Brand";
  //           console.log(`User selected: ${optionIdForHere}`);
  //           console.log(`selected: Brand`);
  //           listingData.listingBrand = optionIdForHere;
  //           listingData.listingModel = "";
  //         } else if (parentConEl.id.includes("Model")) {
  //           Type = "Model";
  //           console.log(`User selected: ${optionIdForHere}`);
  //           console.log(`selected: model`);
  //           listingData.listingModel = optionIdForHere;
  //         } else if (parentConEl.id.includes("Year")) {
  //           Type = "Year";
  //           console.log(`User selected: ${optionIdForHere}`);
  //           console.log(`selected: year`);
  //           listingData.listingYear = optionIdForHere;
  //         } else if (parentConEl.id.includes("Condition")) {
  //           Type = "Condition";
  //           console.log(`User selected: ${optionIdForHere}`);
  //           console.log(`selected: condition`);
  //           listingData.listingCondition = optionIdForHere;
  //         }
  //         this._callTheRightFunction(prefixId, Type);
  //         createdOptions.push(newOption);

  //         if (isMultiple) {
  //           // Allow multiple selections
  //           selectedValues.push(newOption.id);
  //         } else {
  //           // Single selection: Replace the current selection
  //           selectedValues = [newOption.id];
  //         }

  //         renderSelectedOptions();
  //         renderOptionList();
  //         searchInput.value = "";
  //       });

  //       optionList.appendChild(createOption);
  //     }

  //     optionList.classList.add("active");
  //   };

  //   // Handle the search input
  //   searchInput.addEventListener("input", renderOptionList);

  //   // Show option list when input is focused
  //   searchInput.addEventListener("focus", () => {
  //     renderOptionList();
  //     searchInput.placeholder = "Buscar opciones";
  //     optionList.classList.add("active");
  //   });

  //   // Hide option list when input loses focus or user clicks outside
  //   parentAllConEl.addEventListener("click", (e) => {
  //     if (!searchInput.contains(e.target) && !optionList.contains(e.target)) {
  //       optionList.classList.remove("active");
  //     }
  //   });

  //   // Prevent closing the dropdown when clicking on the options or removing selected options
  //   optionList.addEventListener("click", (e) => {
  //     if (
  //       e.target.classList.contains("option-item") ||
  //       e.target.classList.contains("create-option")
  //     ) {
  //       if (isMultiple) {
  //         e.stopPropagation(); // Prevent closing the dropdown when an option is clicked
  //       }
  //     }
  //   });

  //   selectedOptionsDiv.addEventListener("click", (e) => {
  //     if (e.target.classList.contains("remove")) {
  //       e.stopPropagation(); // Prevent closing the dropdown when the "x" is clicked
  //     }
  //   });
  //   if (
  //     listingData.listingBrand &&
  //     listingData.listingModel &&
  //     !this.#initialPreselectedSet
  //   ) {
  //     console.log("these here");
  //     this._setMachineBrand(prefixId);
  //     this._setMachineModel(prefixId);
  //     this.#initialPreselectedSet = true;
  //     this._setOtherData();
  //   } else {
  //     console.log("not set");
  //   }
  // };

  _callTheRightFunction = (prefixId, Type) => {
    console.log("called with:", prefixId, Type);
    console.log("data now:", listingData);
    const machineSelect = document.getElementById(
      `SearchStartUpComponentSelectMachineType`
    );
    const brandSelect = document.getElementById(
      `SearchStartUpComponentSelectMachineBrand`
    );
    const modelSelect = document.getElementById(
      `SearchStartUpComponentSelectMachineModel`
    );
    if (Type === "Type") {
      brandSelect.querySelector("#selected-options").innerHTML = "";
      brandSelect.querySelector("#option-list").innerHTML = "";

      this.#machineBrandsOnCleared = true;
      this.#machineModelsOnCleared = true;

      brandSelect.classList.remove("SearchStartUpComponentCon10Clear");
      modelSelect.classList.remove("SearchStartUpComponentCon10Clear");
      brandSelect.querySelector("#search-input").placeholder = "Selecionar";
      modelSelect.querySelector("#search-input").placeholder = "Selecionar";

      // SearchStartUpComponentCon10Clear

      modelSelect.querySelector("#selected-options").innerHTML = "";
      modelSelect.querySelector("#option-list").innerHTML = "";
      if (!listingData.listingMachineType) return;
      this._setMachineBrand(prefixId);
    }
    if (Type === "Brand") {
      this.#machineModelsOnCleared = true;
      modelSelect.classList.remove("SearchStartUpComponentCon10Clear");

      modelSelect.querySelector("#selected-options").innerHTML = "";
      modelSelect.querySelector("#option-list").innerHTML = "";
      modelSelect.querySelector("#search-input").placeholder = "Selecionar";

      if (!listingData.listingBrand) return;
      this._setMachineModel(prefixId);
    }
  };
  _setMachineTypes = async (prefixId) => {
    const SearchStartUpComponentSelectMachineType = document.getElementById(
      `SearchStartUpComponentSelectMachineType`
    );
    SearchStartUpComponentSelectMachineType.querySelector(
      "#search-input"
    ).value = listingData.listingMachineType;
    spinner._displaySpinner("Cargando información");
    const machineData = await firebase._getMachineData("machineTypes");
    this._initiateSelectOptions(
      false,
      `SearchStartUpComponentSelectMachineType`,
      `SearchStartUpComponentAllCon`,
      prefixId,
      machineData
    );
    spinner._hideSpinner();
  };
  _setMachineBrand = async (prefixId) => {
    const SearchStartUpComponentSelectMachineBrand = document.getElementById(
      `SearchStartUpComponentSelectMachineBrand`
    );
    SearchStartUpComponentSelectMachineBrand.querySelector(
      "#search-input"
    ).value = listingData.listingBrand;

    spinner._displaySpinner("Cargando marcas");
    let machineDataForUse;
    const machineData = await firebase._getMachineData(
      `machineTypes/${listingData.listingMachineType}/brands`
    );
    if (machineData.length < 1) {
      machineDataForUse = [{ id: "marca" }];
    } else {
      machineDataForUse = machineData;
    }
    this.#machineBrandsOnCleared = false;
    this.#machineModelsOnCleared = false;
    this._initiateSelectOptions(
      false,
      `SearchStartUpComponentSelectMachineBrand`,
      `SearchStartUpComponentAllCon`,
      prefixId,
      machineDataForUse,
      listingData.listingBrand
    );

    spinner._hideSpinner();
  };
  _setMachineModel = async (prefixId) => {
    const SearchStartUpComponentSelectMachineModel = document.getElementById(
      `SearchStartUpComponentSelectMachineModel`
    );
    SearchStartUpComponentSelectMachineModel.querySelector(
      "#search-input"
    ).value = listingData.listingModel;
    spinner._displaySpinner("Cargando modelos");
    let machineDataForUse;
    const machineData = await firebase._getMachineData(
      `machineTypes/${listingData.listingMachineType}/brands/${listingData.listingBrand}/models`
    );

    if (machineData.length < 1) {
      machineDataForUse = [{ id: "modelo" }];
    } else {
      machineDataForUse = machineData;
    }

    this.#machineModelsOnCleared = false;
    this._initiateSelectOptions(
      false,
      `SearchStartUpComponentSelectMachineModel`,
      `SearchStartUpComponentAllCon`,
      prefixId,
      machineDataForUse,
      listingData.listingModel
    );
    spinner._hideSpinner();
  };
  _setMachineYears = async (prefixId) => {
    const SearchStartUpComponentSelectMachineYear = document.getElementById(
      `SearchStartUpComponentSelectMachineYear`
    );
    SearchStartUpComponentSelectMachineYear.querySelector(
      "#search-input"
    ).value = listingData.listingYear;

    const years = GENRALHELPERS._generateYearsArray(1990);
    const stringYearsOptions = [];

    years.forEach((year) => {
      stringYearsOptions.push({ id: year.toString() });
    });
    this._initiateSelectOptions(
      false,
      `SearchStartUpComponentSelectMachineYear`,
      `SearchStartUpComponentAllCon`,
      prefixId,
      stringYearsOptions,
      listingData.listingYear
    );
  };
  _setMachineConditions = async (prefixId) => {
    const SearchStartUpComponentSelectMachineCondition =
      document.getElementById(
        `SearchStartUpComponentSelectMachineCondition`
      );
    SearchStartUpComponentSelectMachineCondition.querySelector(
      "#search-input"
    ).value = listingData.listingCondition;

    const conditions = ["nuevo", "usado"];
    const stringConditionOptions = [];

    conditions.forEach((condition) => {
      stringConditionOptions.push({ id: condition.toString() });
    });
    this._initiateSelectOptions(
      false,
      `SearchStartUpComponentSelectMachineCondition`,
      `SearchStartUpComponentAllCon`,
      prefixId,
      stringConditionOptions,
      listingData.listingCondition
    );
  };
  _setOtherData() {
    // const coinPickerCon = document.getElementById("CreateListingCoinPic");
    // const coinMXN = document.getElementById("CreateListingCoinPicMXN");
    // const coinUSD = document.getElementById("CreateListingCoinPicUSD");
    const CreateListingPrice = document.getElementById(
      `CreateListingPrice`
    );
    const CreateListingItemsAvailable = document.getElementById(
      `CreateListingItemsAvailable`
    );
    const CreateListingName = document.getElementById(
      `CreateListingName`
    );
    const CreateListingVideoURL = document.getElementById(
      `CreateListingVideoURL`
    );
    const CreateListingDiscountPercent = document.getElementById(
      `CreateListingDiscountPercent`
    );
    const CreateListingDiscountAmount = document.getElementById(
      `CreateListingDiscountAmount`
    );
    const CreateListingDiscountFinalPrice = document.getElementById(
      `CreateListingDiscountFinalPrice`
    );
    const CreateListingDescription = document.getElementById(
      `CreateListingDescription`
    );
    const CreateListingAdminNotes = document.getElementById(
      `CreateListingAdminNotes`
    );
    console.log(listingData.onDiscount);

    let videoUrl = listingData.videoUrl;
    if (!videoUrl) {
      videoUrl = "";
    }

    CreateListingName.value = listingData.listingName;
    CreateListingVideoURL.value = videoUrl;
    CreateListingPrice.value = listingData.listingPrice;
    CreateListingItemsAvailable.value = listingData.listingItemsAvailable;
    CreateListingDescription.textContent = listingData.listingDescription;
    CreateListingAdminNotes.textContent = listingData?.adminNotes || '';
    CreateListingDiscountPercent.value = listingData.onDiscount.percent;
    CreateListingDiscountAmount.value = listingData.onDiscount.amount;
    CreateListingDiscountFinalPrice.value = listingData.onDiscount.finalPrice;

    if (videoUrl.length > 1) {
      this._setVideoStatus(true)
    }

    // if (listingData.listingCoin === "MXN") {
    //   listingData.listingCoin = "MXN";
    //   // coinPickerCon.dataset.coin = "MXN";
    //   coinUSD.classList.remove("CreateListingOptionsPicCon3Active");
    //   coinMXN.classList.add("CreateListingOptionsPicCon3Active");
    // }
    // if (listingData.listingCoin === "USD") {
    //   listingData.listingCoin = "USD";
    //   coinPickerCon.dataset.coin = "USD";
    //   coinUSD.classList.add("CreateListingOptionsPicCon3Active");
    //   coinMXN.classList.remove("CreateListingOptionsPicCon3Active");
    // }
  }
}
export default new CreateListing();
